import { render, staticRenderFns } from "./LondonCalling.vue?vue&type=template&id=a14aca7a&"
import script from "./LondonCalling.vue?vue&type=script&lang=js&"
export * from "./LondonCalling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports